<div class="container-fluid">
  <div class="header-container">

    <div class="row   justify-content-start mb-2">
      <div class="col-12">
        <span class="iso-header ml-2">
          {{ "bikeshop.menu.shop_profile" | translate }}
        </span>
      </div>
    </div>
  </div>
  <div>
    <div *ngIf="ShopForm">
      <div class="row">
        <div class="col-md-7 content">
          <form [formGroup]="ShopForm" (ngSubmit)="savePartner(ShopForm.value)">
            <div class="row margin-top-8">
              <div class="col-md-4 label">
                *{{ "general.name" | translate }}:
              </div>
              <div class="col-md-8">
                <div class="p-inputgroup">
                  <input type="text" pInputText placeholder="{{ 'general.name' | translate }}" formControlName="Name" />
                </div>
              </div>
            </div>

            <div class="row margin-top-8">
              <div class="col-md-4 label">
                *{{ "general.description" | translate }}:
              </div>
              <div class="col-md-8">
                <div class="p-inputgroup">
                  <textarea pInputTextarea [rows]="5" placeholder="{{
                      'bikeshop.shop_profile.store_description' | translate
                    }}" formControlName="Description"></textarea>
                </div>
              </div>
            </div>

            <div class="row margin-top-8">
              <div class="col-md-4 label">
                *{{ "general.email" | translate }}:
              </div>
              <div class="col-md-8">
                <div class="p-inputgroup">
                  <input type="text" pInputText formControlName="eMail"
                    placeholder="{{ 'general.email' | translate }}" />
                </div>
              </div>
            </div>

            <div class="row margin-top-8">
              <div class="col-md-4 label">
                {{ "general.phone_number" | translate }}:
              </div>
              <div class="col-md-8">
                <div class="p-inputgroup">
                  <input type="text" pInputText formControlName="PhoneNumber1"
                    placeholder="{{ 'general.phone_number' | translate }}" />
                </div>
              </div>
            </div>

            <div class="row margin-top-8">
              <div class="col-md-4 label">
                {{ "bikeshop.shop_profile.address" | translate }}:
              </div>
              <div class="col-md-8">
                <div class="p-inputgroup">
                  <textarea pInputTextarea [rows]="5" formControlName="PhysicalAddress" placeholder="{{
                      'bikeshop.shop_profile.physical_address' | translate
                    }}"></textarea>
                </div>
              </div>
            </div>

            <div class="row margin-top-8">
              <div class="col-md-4 label">
                {{ "bikeshop.shop_profile.web_address" | translate }}:
              </div>
              <div class="col-md-8">
                <div class="p-inputgroup">
                  <input type="text" pInputText formControlName="WebAddress" placeholder="{{
                      'bikeshop.shop_profile.web_address' | translate
                    }}" />
                </div>
              </div>
            </div>

            <div class="row margin-top-8">
              <div class="col-md-4 label">
                {{ "bikeshop.shop_profile.minimum_jobcard_no" | translate }}:
              </div>
              <div class="col-md-8">
                <div class="p-inputgroup">
                  <input type="number" pInputText formControlName="MinimumJobcardNo" placeholder="{{
                      'bikeshop.shop_profile.minimum_jobcard_no' | translate
                    }}" />
                </div>
              </div>
            </div>
            <div class="row margin-top-8">
              <div class="col-md-4 label">
                {{
                "bikeshop.shop_profile.offers_mobile_bookings" | translate
                }}:
              </div>
              <div class="col-md-8">
                <div class="p-inputgroup">
                  <p-inputSwitch formControlName="OffersBookingService"></p-inputSwitch>
                </div>
              </div>
            </div>
            <div class="row margin-top-8">
              <div class="col-md-4 label">
                {{
                "bikeshop.shop_profile.offers_fitting_bookings" | translate
                }}:
              </div>
              <div class="col-md-8">
                <div class="p-inputgroup">
                  <p-inputSwitch formControlName="OffersFittingService"></p-inputSwitch>
                </div>
              </div>
            </div>

            <div class="row margin-top-8">
              <div class="col-md-4 label">
                {{ "bikeshop.shop_profile.country" | translate }}:
              </div>
              <div class="col-md-8">
                <div class="p-inputgroup">
                  <p-dropdown [options]="countries" formControlName="Country" placeholder="{{
                      'bikeshop.shop_profile.country' | translate
                    }}">
                    <ng-template let-country pTemplate="country">
                      <img src="/assets/flags/1x1/{{ country.flag }}" style="width: 20px; vertical-align: middle;" />
                      <span style="margin-left: 0.25em;">
                        {{
                        country.label
                        }}
                      </span>
                    </ng-template>
                  </p-dropdown>
                </div>
              </div>
            </div>
            <div class="row margin-top-8">
              <div class="col-md-4 label">
                
              </div>
              <div class="col-md-8">
                <div class="p-inputgroup">
                  <p-dropdown [options]="timeZones" formControlName="TimeZone" placeholder="Timezone" (onChange)="saveTimezone()"></p-dropdown>
                </div>
              </div>
            </div>
            <div class="row margin-top-8">
              <div class="col-md-4 label">
                {{
                "bikeshop.shop_profile.default_unit_of_measure" | translate
                }}:
              </div>
              <div class="col-md-8">
                <p-dropdown [options]="units" class="full-width" formControlName="DefaultUnitOfMeasure" placeholder="{{
                    'bikeshop.shop_profile.default_unit_of_measure' | translate
                  }}">
                </p-dropdown>
              </div>
            </div>

            <div class="row margin-top-8">
              <div class="col-md-4 label">
                {{ "bikeshop.shop_profile.currency_symbol" | translate }}:
              </div>
              <div class="col-md-8">
                <div class="p-inputgroup">
                  <input type="text" pInputText formControlName="CurrencySymbol" placeholder="{{
                      'bikeshop.shop_profile.currency_symbol' | translate
                    }}" />
                </div>
              </div>
            </div>

            <div class="row margin-top-8">
              <div class="col-md-4 label">
                {{ "bikeshop.shop_profile.vat_inclusive" | translate }}:
              </div>
              <div class="col-md-8">
                <div class="p-inputgroup">
                  <p-inputSwitch formControlName="VATInclusive"></p-inputSwitch>
                </div>
              </div>
            </div>
            <div class="row margin-top-8">
              <div class="col-md-4 label">
                {{ "bikeshop.shop_profile.vat_rate" | translate }}:
              </div>
              <div class="col-md-8">
                <div class="p-inputgroup">
                  <input type="number" pInputText formControlName="VATRate" placeholder="{{
                      'bikeshop.shop_profile.vat_rate' | translate
                    }}" />
                </div>
              </div>
            </div>
            <div class="row margin-top-8">
              <div class="col-md-4 label">
                {{ "store.profile.show_tax_equal_to_zero" | translate }}:
              </div>
              <div class="col-md-8">
                <div class="p-inputgroup">
                  <p-inputSwitch formControlName="ShowZeroTaxAmounts"></p-inputSwitch>
                  <small style=" margin-left: 8px;  margin-top: auto;  margin-bottom: auto; ">
                    {{"store.profile.show_tax_equal_to_zero_desc" | translate }}
                  </small>
                </div>
              </div>
            </div>
            <div class="row margin-top-8">
              <div class="col-md-4 label">
                {{ "bikeshop.shop_profile.allow_discount" | translate }}:
              </div>
              <div class="col-md-8">
                <div class="p-inputgroup">
                  <p-inputSwitch formControlName="AllowDiscount"></p-inputSwitch>
                  
                  <small style="
                      margin-left: 8px;
                      margin-top: auto;
                      margin-bottom: auto;
                    ">
                    {{
                    "bikeshop.shop_profile.allow_discount_info" | translate
                    }}
                  </small>
                </div>
              </div>
            </div>
            <div class="row margin-top-8">
              <div class="col-md-4 label">
                Store Type:
              </div>
              <div class="col-md-8">
                <div class="p-inputgroup">
                  <p-dropdown [options]="partnerTypes" formControlName="PartnerType">
                  </p-dropdown>
                </div>
              </div>
            </div>
            <div class="row margin-top-8">
              <div class="col-md-4 label">
                {{ "bikeshop.shop_profile.enabletfa" | translate }}:
              </div>
              <div class="col-md-8">
                <div class="p-inputgroup">
                  <p-inputSwitch formControlName="Enable2FA"></p-inputSwitch>
                  <small style="
                      margin-left: 8px;
                      margin-top: auto;
                      margin-bottom: auto;
                    ">
                    {{
                    "bikeshop.shop_profile.enabletfa_description" | translate
                    }}
                  </small>
                </div>
              </div>
            </div>

            <div class="row margin-top-8">
              <div class="col-md-4 label">
                {{ "bikeshop.shop_profile.showgdprmarketingconsent" | translate }}:
              </div>
              <div class="col-md-8">
                <div class="p-inputgroup">
                  <p-inputSwitch formControlName="ShowGDPRMarketingConsent"></p-inputSwitch>
                  <small style="
                      margin-left: 8px;
                      margin-top: auto;
                      margin-bottom: auto;
                    ">
                    {{
                    "bikeshop.shop_profile.showgdprmarketingconsent_info" | translate
                    }}
                  </small>
                </div>
              </div>
            </div>
            <div class="row margin-top-8">
              <div class="col-md-4 label">
                {{ "bikeshop.shop_profile.showgdprmarketingconsent_text" | translate }}:
              </div>
              <div class="col-md-8">
                <div class="p-inputgroup">
                  <textarea pInputTextarea [rows]="5" formControlName="ShowGDPRMarketingConsentCustomText" placeholder="{{
                      'bikeshop.shop_profile.showgdprmarketingconsent_text_placeholder' | translate
                    }}"></textarea>
                </div>
              </div>
            </div>

            <div class="row margin-top-8">
              <div class="col-md-4 label margin-top-0">
                {{ 'bikeshop.shop_profile.freetextmergetag' | translate }}
              </div>
              <div class="col-md-8 value">
                <quill-editor [style]="{'height':'220px'}" formControlName="FreeTextMergeTag" format="html"
                  placeholder="{{ 'bikeshop.shop_profile.freetextmergetag_info' | translate}}">
                </quill-editor>
                <!--             todo(dcorbett)  [modules]="modules" -->
              </div>
            </div>
            <hr>
            <div class="row margin-top-8">
              <div class="col-md-4 label">
                Trustpilot URL
              </div>
              <div class="col-md-8">
                <div class="p-inputgroup">
                  <input type="text" pInputText formControlName="ReviewTrustPilotUrl"
                    placeholder="Your shop Trustpilot URL" />
                </div>
                <!-- <small>Follow this <a href="#">guide</a> to create or find your Shop's Trustpilot Review URL.</small> -->
              </div>
            </div>
            <div class="row margin-top-8">
              <div class="col-md-4 label">
                Google Reviews URL
              </div>
              <div class="col-md-8">
                <div class="p-inputgroup">
                  <input type="text" pInputText formControlName="ReviewGoogleUrl"
                    placeholder="Your shop Google Review URL" />
                </div>
                <!-- <small>Follow this <a href="#">guide</a> to find your Shop's Google Review URL.</small> -->
              </div>
            </div>
            <div *ngIf="ShopForm.value.PartnerType == 1 && isWorkshop">
              <hr>
              <div class="row margin-top-8">
                <div class="col-md-4 label">
                  <div class="project529">
                    <span>{{ "bikeshop.shop_profile.project_529_activate" | translate }}:</span>
                    <!-- <img src="./assets/project529/logo_2.png"> -->
                  </div>
                </div>
                <div class="col-md-8">
                  <div class="p-inputgroup">
                    <p-inputSwitch formControlName="Project529Enabled"></p-inputSwitch>
                    <small class="project529" innerHTML="{{'bikeshop.shop_profile.project_529_info' | translate}}">                      
                    </small>
                  </div>
                </div>
              </div>

            </div>

            <div class="row margin-top-16">
              <div class="col-md-4"></div>
              <div class="col-md-4">
                <button type="submit" class="iso-round-button" [disabled]="!ShopForm.valid || busy">{{
                  'bikeshop.shop_profile.button.update_profile' | translate
                  }}</button>
              </div>
            </div>
            <div class="row">
              <!--              todo (dcorbett) no error-->
              <!--              <div *ngIf="error" class="col-md-12 errormessage">-->
              <!--                {{ errorMessage }}-->
              <!--              </div>-->
            </div>
          </form>
        </div>
        <div class="col-md-5">
          <div>
            <div class="image-container content">
              <div class="row">
                <div class="col-md-12">
                  <div class="sub-header margin-bottom-16">{{ "bikeshop.shop_profile.shop_logo" | translate }}</div>
                </div>
              </div>
              <div class="profile-image">
                <img [src]="partner.ImageURL" />
              </div>
              <div class="row margin-top-16">
                <div class="col-md-6">
                  <button (click)="updateProfileLogo.click()" class="iso-round-button iso-light" [disabled]="busy">{{
                    'bikeshop.shop_profile.button.update_logo' | translate
                    }}</button>
                </div>
              </div>
              <input #updateProfileLogo type="file" style="display: none;" (change)="updateLogo($event)" />
            </div>

            <div class="image-container content">
              <div class="row">
                <div class="col-md-12">
                  <div class="sub-header margin-bottom-16">{{ "bikeshop.shop_profile.shop_profile_image" | translate }}
                  </div>
                </div>
              </div>
              <div class="shop-image" *ngIf="fallBackImage || partner.PartnerImage">
                <img [src]="partner.PartnerImage ? partner.PartnerImage : fallBackImage" />
              </div>
              <div class="row margin-top-16">
                <div class="col-md-6">
                  <button class="iso-round-button iso-light" (click)="updateProfileImage.click()" [disabled]="busy">{{
                    'bikeshop.shop_profile.button.update_profile_image' | translate
                    }}</button>
                </div>
              </div>
              <input #updateProfileImage type="file" style="display: none;" (change)="updatePhoto($event)" />
            </div>
          </div>
        </div>
        <p-confirmDialog></p-confirmDialog>
      </div>
    </div>
  </div>
  <!-- <app-collections-setup
  ></app-collections-setup>
  <app-pos-integrations></app-pos-integrations> -->
</div>
<p-toast position="bottom-right" styleClass="hubtiger-toast"></p-toast>
